import RecaptchaFix from "../../utils/RecaptchaFix";
import BaseDeviseController from "./BaseDeviseController";

export default class SessionsNew extends BaseDeviseController {

    constructor() {
        super();
        this.recaptchaFix = new RecaptchaFix('#login_form');
        this.initValidation();
        this.setPasswordVisibility();
        this.bindEvents();
        this.toggleSubmit();
    }


    bindEvents() {
        $(`#${this.resource_name}_email`).off( 'input', this.toggleSubmit ).on("input", () => this.toggleSubmit() )
        $(`#${this.resource_name}_password`).off( 'input', this.toggleSubmit ).on("input", () => this.toggleSubmit() )
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.recaptchaFix.onDestroy();
    }

    toggleSubmit() {

        let email = $(`#${this.resource_name}_email`).val();
        let password = $(`#${this.resource_name}_password`).val();
        if( email.trim().length>0 && password.trim().length>0 ) {
            $('#btn-login').removeClass('disabled')
        } else {
            $('#btn-login').addClass('disabled')
        }
    }

    initValidation() {
        application.setTemplateValidation({
            [ `${this.resource_name}[email]` ]: {
                required: true,
                email_validation: true
            },
            [ `${this.resource_name}[password]` ]: {
                required: true
            }
        }, '#login_form')
    }
}